// import { usersConnected, userDisconnected } from './modules/User/UserActions';
import appListener from './modules/App/AppSocket';
import userListener from './modules/User/UserSocket';
import sessionListener from './modules/Session/SessionSocket';
import applicantListener from './modules/Applicant/ApplicantSocket';
import conversationListener from './modules/Conversation/ConversationSocket';
import correctionListener from './modules/Correction/CorrectionSocket';
import { notifyError } from './components/Error/ErrorBoundary';

let loggedInUser = null;

const listeners = [appListener, userListener, sessionListener, applicantListener, conversationListener, correctionListener];

export default function(socket, dispatch, intl) {
    console.log('Websocket::: Init');
    listeners.forEach(listener => listener(socket, dispatch, intl, getUser));

    socket.on('connect', () => {
        console.log('Websocket::: Connected');
    });
    socket.on('error', error => {
        console.error('Websocket::: Error', error);
        notifyError(error);
    });
    socket.on('reconnect_error', error => {
        console.error('Websocket::: Error: reconnect', error);
        notifyError(error);
    });
    socket.on('reconnect_failed', error => {
        console.error('Websocket::: Error: reconnect: failed', error);
        notifyError(error);
    });

    // // User
    // socket.on('connectedUsers', users => {
    //     dispatch(usersConnected(users));
    // });
    //
    // socket.on('userDisconnected', user => {
    //     dispatch(userDisconnected(user));
    // });
    //
}

export function setSocketUser(user) {
    // console.log('Socket::: setUser', user);
    loggedInUser = user;
}

function getUser() {
    // console.log('Socket::: getUser', loggedInUser);
    return loggedInUser;
}
